"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7678],{

/***/ 49986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppRadioBtn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var reactstrap_lib_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72445);
/* harmony import */ var reactstrap_lib_Label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3879);




const AppRadioBtn = ({ id, name, labelText, value, isChecked, onChange, style, className, labelClassName, inputClassName }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", height: "22px", fontSize: "1rem", letterSpacing: "-0.01rem", cursor: "pointer" }, style), { marginLeft: `calc(${(style === null || style === void 0 ? void 0 : style.marginLeft) || "0px"} + 22px)` }), className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Label__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { check /* for={name} */: true, style: { margin: 0, cursor: "pointer" }, className: labelClassName },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { id: id, type: "radio", name: name, value: value, checked: isChecked, onChange: onChange, style: {
                    height: "22px",
                    width: "22px",
                    margin: 0,
                    cursor: "pointer",
                    marginLeft: "calc(-22px - 9px)"
                }, className: inputClassName }),
            labelText)));
};


//# sourceMappingURL=AppRadioBtn.js.map


/***/ }),

/***/ 28941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badge; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/badge/Badge.module.scss.js


var css_248z = ".Badge-module_badge__qMpZf {\n  padding: 1px 10px;\n  border-radius: 9.5px;\n  font-size: 0.75rem;\n  color: #666666;\n  background-color: #e4e4e4;\n  text-align: center;\n}\n.Badge-module_badge__qMpZf.Badge-module_clickable__snffm {\n  cursor: pointer;\n}\n.Badge-module_badge__qMpZf.Badge-module_outLined__Ze0Lb {\n  background-color: #ffffff !important;\n  border: 2px solid #e9e9e9;\n}\n.Badge-module_badge__qMpZf.Badge-module_squaredEdges__Q6MpT {\n  border-radius: 4px 0;\n}\n.Badge-module_badge__qMpZf.Badge-module_active__erKuo {\n  color: #25d365;\n  background-color: #c7ffdb;\n}\n.Badge-module_badge__qMpZf.Badge-module_progress__O3QBI {\n  color: #5938fb;\n  background-color: #dcd4ff;\n}\n.Badge-module_badge__qMpZf.Badge-module_warning__G8b4G {\n  color: #e78500;\n  background-color: #ffe9c2;\n}\n.Badge-module_badge__qMpZf.Badge-module_published__WhPvO {\n  color: #2355fc;\n  background-color: #d3deff;\n}\n\n@media (max-width: 991px) {\n  .Badge-module_badge__qMpZf {\n    width: fit-content;\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    padding: 0px 9px;\n    font-size: 0.6875rem;\n    transform: translateY(-2px);\n  }\n}";
var Styles = {"badge":"Badge-module_badge__qMpZf","clickable":"Badge-module_clickable__snffm","outLined":"Badge-module_outLined__Ze0Lb","squaredEdges":"Badge-module_squaredEdges__Q6MpT","active":"Badge-module_active__erKuo","progress":"Badge-module_progress__O3QBI","warning":"Badge-module_warning__G8b4G","published":"Badge-module_published__WhPvO"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=Badge.module.scss.js.map

// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ../core/dist/components/badge/Badge.js





const Badge = ({ text, type = misc/* BadgeTypes.DEFAULT */.nJ.DEFAULT, outLined = false, squaredEdges = false, isClickable = false, badgeClass, onClick, id = "" }) => {
    const returnStyleClassName = () => {
        if (type === misc/* BadgeTypes.ACTIVE */.nJ.ACTIVE)
            return "active";
        else if (type === misc/* BadgeTypes.PROGRESS */.nJ.PROGRESS)
            return "progress";
        else if (type === misc/* BadgeTypes.WARNING */.nJ.WARNING)
            return "warning";
        else if (type === misc/* BadgeTypes.PUBLISHED */.nJ.PUBLISHED)
            return "published";
        else
            return "";
    };
    return (react.createElement("div", { id: id, className: classnames_default()(Styles.badge, Styles[returnStyleClassName()], outLined && Styles.outLined, squaredEdges && Styles.squaredEdges, isClickable && Styles.clickable, badgeClass), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick() }, text));
};


//# sourceMappingURL=Badge.js.map


/***/ }),

/***/ 19145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BottomSheet; }
});

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/bottom-sheet/BottomSheet.module.scss.js


var css_248z = ".BottomSheet-module_topLine__40w0P {\n  margin: 5px auto;\n  width: 12vw;\n  height: 4px;\n  border-radius: 100px;\n  background-color: grey;\n  opacity: 0.5;\n}\n\n.BottomSheet-module_bottomSheetHeader__55csP {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 15px 0;\n}\n.BottomSheet-module_bottomSheetHeader__55csP .BottomSheet-module_bottomSheetTitle__M3FGj {\n  font-family: var(--font-semiBold);\n  font-size: 22px;\n  color: #333333;\n}\n.BottomSheet-module_bottomSheetHeader__55csP .BottomSheet-module_closeIcon__Xzq1d {\n  background-color: #969696;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.BottomSheet-module_bottomSheetHeader__55csP .BottomSheet-module_closeIcon__Xzq1d svg {\n  width: 10px;\n  height: 10px;\n  margin: 0 !important;\n  top: 0 !important;\n}\n.BottomSheet-module_bottomSheetHeader__55csP .BottomSheet-module_closeIcon__Xzq1d svg path {\n  stroke: #ffffff;\n}";
var Styles = {"topLine":"BottomSheet-module_topLine__40w0P","bottomSheetHeader":"BottomSheet-module_bottomSheetHeader__55csP","bottomSheetTitle":"BottomSheet-module_bottomSheetTitle__M3FGj","closeIcon":"BottomSheet-module_closeIcon__Xzq1d"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=BottomSheet.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/bottom-sheet/BottomSheet.scss.js


var BottomSheet_scss_css_248z = ".ReactSwipeableBottomSheet--open {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}";
(0,style_inject_es/* default */.Z)(BottomSheet_scss_css_248z);


//# sourceMappingURL=BottomSheet.scss.js.map

;// CONCATENATED MODULE: ../core/dist/icons/nf_closeWhite.svg.js


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNfCloseWhite(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 1L1 12m11 0L1 1"
  })));
}


//# sourceMappingURL=nf_closeWhite.svg.js.map

;// CONCATENATED MODULE: ../core/dist/components/bottom-sheet/BottomSheet.js






const SwipeableBottomSheet = __webpack_require__(92429);
const BottomSheet = ({ isOpen, handleToggle, children, className, id, bottomSheetTitle, titleClass, closeIconClass, topLineClass, fullScreen = false, bottomSheetHeaderClassName, bodyBgColor, style, disableSwipe = false }) => {
    (0,react.useEffect)(() => {
        const body = document.querySelector("body");
        if (body) {
            body.style.overflow = isOpen ? "hidden" : "unset";
        }
        return () => {
            const body = document.querySelector("body");
            if (!body) {
                return;
            }
            body.style.overflow = "unset";
        };
    }, [isOpen]);
    const onChange = () => {
        handleToggle();
    };
    if (!isOpen)
        return react.createElement(react.Fragment, null);
    return (react.createElement(SwipeableBottomSheet, { open: isOpen, handleToggle: handleToggle, shadowTip: false, topShadow: false, style: Object.assign({ zIndex: 1000 }, style), overlayStyle: { backgroundColor: "rgba(0,0,0)" }, onChange: onChange, fullScreen: fullScreen, bodyStyle: { backgroundColor: bodyBgColor !== null && bodyBgColor !== void 0 ? bodyBgColor : "#fff" }, swipeableViewsProps: {
            disabled: disableSwipe
        } },
        react.createElement("div", { className: classnames_default()(Styles.topLine, topLineClass) }),
        bottomSheetTitle && (react.createElement("div", { className: classnames_default()(Styles.bottomSheetHeader, "container", bottomSheetHeaderClassName) },
            react.createElement("div", { className: classnames_default()(Styles.bottomSheetTitle, titleClass) }, bottomSheetTitle),
            react.createElement("div", { className: classnames_default()(Styles.closeIcon, closeIconClass), onClick: handleToggle, id: id ? `${id}--closeBtn` : "" },
                react.createElement(SvgNfCloseWhite, null)))),
        react.createElement("div", { className: classnames_default()(Styles.contentMain, className, "container") }, children)));
    // return <></>;
};


//# sourceMappingURL=BottomSheet.js.map


/***/ }),

/***/ 33259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FilterSelectField; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js + 9 modules
var react_select_esm = __webpack_require__(74800);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/filter-select-field/FilterSelectField.module.scss.js


var css_248z = ".FilterSelectField-module_selectContainer__Bm-0- {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 180px;\n  width: fit-content;\n  height: 42px;\n  gap: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n  flex-grow: 0;\n  border-radius: 6px;\n  border: solid 2px #e9e9e9;\n  background-color: #fff;\n  padding-top: 4px;\n  cursor: pointer;\n}\n.FilterSelectField-module_selectContainer__Bm-0- .FilterSelectField-module_statusOption__yPzbE {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.FilterSelectField-module_select__L-Jel {\n  border: none;\n  min-width: 50px;\n  width: 100%;\n  outline: none;\n  color: #000000;\n  font-family: var(--font-semiBold);\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  z-index: 200;\n}\n.FilterSelectField-module_select__L-Jel.FilterSelectField-module_nativeSelect__FHCyE {\n  height: unset;\n  z-index: auto;\n  background-color: transparent;\n}\n\n.FilterSelectField-module_label__Z3h0f {\n  color: #666666;\n  font-family: var(--font-medium);\n  height: fit-content;\n  font-size: 14px;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n\n.FilterSelectField-module_error__OuB-T {\n  color: red;\n  font-size: 0.6875rem;\n  position: absolute;\n  bottom: -18px;\n  display: block;\n}\n\n@media (max-width: 991px) {\n  .FilterSelectField-module_select__L-Jel {\n    padding: 7px 3px 7px 0;\n    font-size: 0.8125rem;\n    height: 40px;\n  }\n  .FilterSelectField-module_downArrow__A-PL0 {\n    bottom: 4px;\n  }\n  .FilterSelectField-module_downArrow__A-PL0 svg {\n    width: 7px;\n    height: 10px;\n  }\n  .FilterSelectField-module_label__Z3h0f {\n    top: -5px;\n    left: 0;\n    font-size: 0.6875rem;\n  }\n}";
var Styles = {"selectContainer":"FilterSelectField-module_selectContainer__Bm-0-","statusOption":"FilterSelectField-module_statusOption__yPzbE","select":"FilterSelectField-module_select__L-Jel","nativeSelect":"FilterSelectField-module_nativeSelect__FHCyE","label":"FilterSelectField-module_label__Z3h0f","error":"FilterSelectField-module_error__OuB-T","downArrow":"FilterSelectField-module_downArrow__A-PL0"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=FilterSelectField.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/filter-select-field/select.scss.js


var select_scss_css_248z = ".filterSelectField__control {\n  background-color: rgba(0, 0, 0, 0) !important;\n  border: none !important;\n  border-radius: 0px !important;\n  box-shadow: none !important;\n  cursor: pointer !important;\n  z-index: 1;\n}\n\n.filterSelectField__value-container {\n  padding: 0px !important;\n}\n\n.filterSelectField__indicator-separator {\n  display: none !important;\n}\n\n.filterSelectField__indicator {\n  display: none !important;\n}\n\n.filterSelectField__control--is-focused {\n  outline: none !important;\n  border: none !important;\n}\n\n.filterSelectField__placeholder {\n  color: #666666 !important;\n  font-family: var(--font-medium);\n}\n\n.filterSelectField__option--is-selected {\n  background-color: #e8e8e8 !important;\n  color: #000000 !important;\n}\n\n@media (min-width: 992px) {\n  .filterSelectField__placeholder {\n    top: 14px !important;\n  }\n}\n.filterSelectField__menu {\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2) !important;\n}\n\n.filterSelectField__menu-list {\n  width: max-content;\n  z-index: 10000 !important;\n  position: relative !important;\n  background-color: #fff !important;\n  border-radius: 4px !important;\n}\n\n.filterSelectField__option {\n  font-size: 0.875rem !important;\n}";
(0,style_inject_es/* default */.Z)(select_scss_css_248z);


//# sourceMappingURL=select.scss.js.map

;// CONCATENATED MODULE: ../core/dist/icons/DownArrowGrey.svg.js


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDownArrowGrey(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none",
    viewBox: "0 0 15 9"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#797979",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M2 2l5.5 5.5L13 2"
  })));
}


//# sourceMappingURL=DownArrowGrey.svg.js.map

;// CONCATENATED MODULE: ../core/dist/components/filter-select-field/FilterSelectField.js







const FilterSelectField = ({ classWrapper, classContainer, classLabel, classError, classDownArrow, classSelect, labelText, error, value, name, id, onChange, dropDownList, icon, placeholder, isSearchable, useNativeSelect }) => {
    const selectFieldRef = (0,react.useRef)(null);
    return (react.createElement("div", { className: classnames_default()(Styles.selectContainer, classContainer), onClick: () => { var _a; return (_a = selectFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } },
        react.createElement("label", { htmlFor: "", className: classnames_default()(Styles.label, classLabel) }, labelText),
        react.createElement(react_select_esm["default"], { className: classnames_default()(Styles.select, classSelect), openMenuOnFocus: true, classNamePrefix: "filterSelectField", value: value, onChange: onChange, options: dropDownList, name: name, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, isSearchable: isSearchable, formatOptionLabel: (e) => (react.createElement("span", { className: classnames_default()(Styles.statusOption), style: { color: e.color } }, e.label)), ref: selectFieldRef, maxMenuHeight: 160 }),
        react.createElement("span", { className: classnames_default()(Styles.downArrow, classDownArrow) },
            react.createElement(SvgDownArrowGrey, null)),
        react.createElement("span", { className: classnames_default()(Styles.error, classError) }, error)));
};


//# sourceMappingURL=FilterSelectField.js.map


/***/ }),

/***/ 13323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchField; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/search-field/SearchField.module.scss.js


var css_248z = ".SearchField-module_searchFieldWrapper__F8RI8 {\n  margin: 23px 0;\n}\n.SearchField-module_searchFieldWrapper__F8RI8 .SearchField-module_inputWrapper__X2Fv1 {\n  position: relative;\n}\n.SearchField-module_searchFieldWrapper__F8RI8 .SearchField-module_inputWrapper__X2Fv1 input {\n  min-width: 245px;\n  width: 100%;\n  height: 40px;\n  flex-grow: 0;\n  padding: 12px 11.1px 11px 16px;\n  border-radius: 6px;\n  background-color: #f2f2f2;\n  border: none;\n}\n.SearchField-module_searchFieldWrapper__F8RI8 .SearchField-module_inputWrapper__X2Fv1 input::placeholder {\n  opacity: 0.9;\n  font-family: var(--font-medium);\n  font-size: 14px;\n  font-weight: 500;\n  color: #999999;\n}\n.SearchField-module_searchFieldWrapper__F8RI8 .SearchField-module_inputWrapper__X2Fv1 .SearchField-module_iconWrapper__TbWhn {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n}\n\n@media (max-width: 991px) {\n  .SearchField-module_searchFieldWrapper__F8RI8 {\n    width: 100%;\n  }\n}";
var Styles = {"searchFieldWrapper":"SearchField-module_searchFieldWrapper__F8RI8","inputWrapper":"SearchField-module_inputWrapper__X2Fv1","iconWrapper":"SearchField-module_iconWrapper__TbWhn"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=SearchField.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/icons/Search.svg.js


var _mask, _g, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _mask || (_mask = /*#__PURE__*/react.createElement("mask", {
    id: "Search_svg__a",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    d: "M1.09 1h12.078v12.116H1.09V1z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "#666",
    mask: "url(#Search_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.13 1.933c-2.818 0-5.11 2.299-5.11 5.125s2.292 5.125 5.11 5.125c2.816 0 5.108-2.3 5.108-5.125 0-2.826-2.292-5.125-5.108-5.125m0 11.183c-3.33 0-6.04-2.718-6.04-6.058S3.8 1 7.13 1s6.038 2.717 6.038 6.058c0 3.34-2.708 6.058-6.038 6.058",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7.13 1.433c-3.095 0-5.61 2.524-5.61 5.625h1c0-2.552 2.07-4.625 4.61-4.625v-1zM1.52 7.058c0 3.1 2.515 5.625 5.61 5.625v-1c-2.54 0-4.61-2.074-4.61-4.625h-1zm5.61 5.625c3.094 0 5.608-2.525 5.608-5.625h-1c0 2.551-2.07 4.625-4.608 4.625v1zm5.608-5.625c0-3.101-2.514-5.625-5.608-5.625v1c2.539 0 4.608 2.073 4.608 4.625h1zM7.13 12.616c-3.053 0-5.54-2.493-5.54-5.558h-1c0 3.615 2.932 6.558 6.54 6.558v-1zM1.59 7.058C1.59 3.992 4.077 1.5 7.13 1.5v-1C3.522.5.59 3.442.59 7.058h1zM7.13 1.5c3.052 0 5.538 2.492 5.538 5.558h1C13.668 3.442 10.738.5 7.13.5v1zm5.538 5.558c0 3.065-2.486 5.558-5.538 5.558v1c3.607 0 6.538-2.943 6.538-6.558h-1z"
  }))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M14.178 15.684a.683.683 0 01-.481-.213l-3.155-3.319a.695.695 0 01.022-.978.687.687 0 01.974.022l3.155 3.32a.692.692 0 01-.515 1.168",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#666",
    d: "M14.178 15.684a.683.683 0 01-.481-.213l-3.155-3.319a.695.695 0 01.022-.978.687.687 0 01.974.022l3.155 3.32a.692.692 0 01-.515 1.168"
  })));
}


//# sourceMappingURL=Search.svg.js.map

;// CONCATENATED MODULE: ../core/dist/components/search-field/SearchField.js






const SearchField = ({ placeholder, onChange, style, searchWrapperClass, value, enableDebounce = false, debounceDuration = 500, limit }) => {
    const [searchString, setSearchString] = (0,react.useState)("");
    const handleSearchFilter = (e) => {
        if (e.target.value === "") {
            setSearchString("");
            onChange("");
        }
        else {
            setSearchString(e.target.value);
        }
    };
    const onSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
            return;
        }
    };
    // Search Debounce
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const delayedQuery = (0,react.useCallback)(lodash_debounce_default()(() => onChange(searchString), debounceDuration), [searchString]);
    (0,react.useEffect)(() => {
        if (searchString !== "") {
            delayedQuery();
        }
        return delayedQuery.cancel;
    }, [searchString, delayedQuery]);
    // useEffect(() => {
    //     if (enableDebounce) {
    //         setSearchString(value);
    //     }
    // }, [value]);
    // Added & Commented By Sudhanshu
    return (react.createElement("div", { className: classnames_default()(Styles.searchFieldWrapper, searchWrapperClass), style: Object.assign({}, style) },
        react.createElement("div", { className: classnames_default()(Styles.inputWrapper) },
            react.createElement("input", { type: "text", placeholder: placeholder, onChange: enableDebounce ? handleSearchFilter : onChange, value: enableDebounce ? searchString : value, onKeyDown: onSearchKeyDown, maxLength: limit }),
            react.createElement("div", { className: classnames_default()(Styles.iconWrapper) },
                react.createElement(SvgSearch, null)))));
};


//# sourceMappingURL=SearchField.js.map


/***/ })

}]);